import { useState, useEffect } from 'react';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';
import PopUpItem from './PopUpItem';
import PageWrapper from '../../../../components/Display/PageWrapper';
import PopUpManager from './PopUpManager';
import styles from '../../../../components/Display/Wrapper.module.scss';
import { confirmDialog } from 'primereact/confirmdialog';

function PopUpPage({ isActive }) {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [popUpList, setPopUpList] = useState(undefined);
  const { accountContext } = useAccountContext();
  const [loading, setLoading] = useState(false);
  const [popUp, setPopUp] = useState(undefined);
  const [layout, setLayout] = useState('grid');

  const fetchPopUpList = async () => {
    await privateFetch('GET', 'maisonmousse', `/cu/${accountContext.id}/popup/`).then((res) => {
      setPopUpList(res);
    });
  };

  useEffect(() => {
    fetchPopUpList();
  }, []);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newPopUpAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une pop-up',
    icon: 'pi-plus'
  };

  const createPopUp = async (popUpForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'maisonmousse',
      `/cu/${accountContext.id}/popup/`,
      'La pop-up a bien été ajoutée',
      JSON.stringify(popUpForm)
    ).then(() => {
      fetchPopUpList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updatePopUp = async (popUpForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'maisonmousse',
      `/cu/${accountContext.id}/popup/${popUp.id}/`,
      'La pop-up a bien été modifiée',
      JSON.stringify(popUpForm)
    ).then(() => {
      fetchPopUpList();
      setLoading(false);
      setPanelIsOpen(false);
    });
  };

  const deletePopUp = async (popUp) => {
    await privateFetch(
      'DELETE',
      'maisonmousse',
      `/cu/${accountContext.id}/popup/${popUp.id}/`,
      "L'adhérent a bien été supprimé"
    ).then(() => {
      fetchPopUpList();
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout === 'grid' ? 'pi-list' : 'pi-th-large'
  };

  const confirmPopupDeletion = (popUp) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette adhérent ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => deletePopUp(popUp)
    });
  };
  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Pop-up" actions={[changeLayoutAction, newPopUpAction]}>
        <div className={styles.pageContentContainer}>
          <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
            {popUpList?.map((popUp, index) => (
              <PopUpItem
                popup={popUp}
                handleClickPopup={() => {
                  setPanelIsOpen(true);
                  setPopUp(popUp);
                }}
                confirmPopupDeletion={() => confirmPopupDeletion(popUp)}
              />
            ))}
          </div>
        </div>

        <PopUpManager
          isOpen={panelIsOpen}
          onClose={() => {
            setPanelIsOpen(false);
            setPopUp(undefined);
          }}
          popup={popUp}
          onUpdate={updatePopUp}
          onCreate={createPopUp}
          loading={loading}
        />
      </PageWrapper>
    </div>
  );
}

export default PopUpPage;
